export default __webpack_public_path__ + "static/media/ic_thailand.2a8d0836.svg";